import eventbus from 'tiny-emitter/instance';
import SelectionBox from '@/core/utils/selectionBox';
import { SEATSTATUS, TYPE } from '@/constants';
import { allowCtrlA, allowEsc } from '../helper';

export default class PosMode {
  constructor(app) {
    this.app = app;
    this.selection = this.app.seatmap.selection;
    this.setup();
    allowCtrlA(this);
    allowEsc(this);
    return this;
  }

  setup() {
    this.initSelectionBox();
    this.addEventListeners();
  }

  addEventListeners() {
    eventbus.on('pos:set', this.setPosOnSelection, this);
  }

  removeEventListeners() {
    eventbus.off('pos:set', this.setPosOnSelection);
  }

  setPosOnSelection(pos) {
    const items = [];
    this.selection.items.forEach((s) => {
      // eslint-disable-next-line max-len
      if (
        ((s.type === TYPE.SEAT && s.seatCanBeUpdated) ||
          (s.type === TYPE.TABLESEAT && s.seatCanBeSelectedOrDeselected)) &&
        s.attributes.status !== SEATSTATUS.DISABLED
      ) {
        items.push(s);
      } else if (s.type === TYPE.TABLE && s.attributes.isGrouped) {
        items.push(...s.seats);
      }
    });
    items.forEach((item) => item.assignPos(pos));
    eventbus.emit('seatmap:pos:updated');
  }

  initSelectionBox() {
    this.selectionBox = new SelectionBox(this.app);
    eventbus.emit('seatmap:changemode');
  }

  removeSelectionBox() {
    this.selectionBox.destroy();
    delete this.selectionBox;
  }

  destroy() {
    this.removeSelectionBox();
    this.removeEventListeners();
  }
}
